var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v25H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#7A8E96",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.167 12.5a8.667 8.667 0 0 0-17.334 0m-2.166 0c0-5.983 4.85-10.833 10.833-10.833 5.983 0 10.833 4.85 10.833 10.833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.833 12.5a8.667 8.667 0 0 0 17.334 0m2.166 0c0 5.983-4.85 10.833-10.833 10.833-5.983 0-10.833-4.85-10.833-10.833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.024 18.456h-1.041a.833.833 0 0 1-.834-.833v-6.458c0-.46.373-.834.834-.834h1.041c.46 0 .834.373.834.834v6.458c0 .46-.373.833-.834.833zM11.15 8.085c0-.438.118-.775.354-1.01.236-.237.573-.355 1.01-.355.425 0 .755.118.99.354.237.236.355.573.355 1.01 0 .417-.118.746-.354.985-.236.24-.566.36-.99.36-.438 0-.775-.12-1.01-.36-.237-.24-.355-.568-.355-.984z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-info.0dc6a83737d820ef96960b842173689b.svg";